import { Phase } from '../constants/app'
import { setSelectedOrderUuid } from '@/redux/reducers/orders'
import { RootState } from '@/redux/store'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { UnknownInputParams, router } from 'expo-router'

export const navigateToOrderDetail = createAsyncThunk<
    void,
    { id: string; params?: UnknownInputParams },
    { state: Pick<RootState, 'screen' | 'orders'> }
>('navigateToOrderDetail', async ({ id, params }, { getState, dispatch }) => {
    const state = getState()
    const { layout } = state.screen
    const order = state.orders.uuidOrderMap[id]

    if (!order) return

    const isArchived = order.phase === Phase.Archived

    if (layout === 'compact') {
        router.navigate({
            pathname: isArchived ? '/archive/[uuid]' : '/orders/[uuid]',
            params: { ...params, uuid: id },
        })
        return
    }

    // Target the existing tabs screen directly, keeping its map mounted.
    router.navigate(isArchived ? '/archive/(tabs)' : '/orders/(tabs)')
    dispatch(setSelectedOrderUuid(id))
})
